import styled from 'styled-components';

export const Wrapper = styled.div<{ isstudent: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: ${({ isstudent }) => (isstudent ? '1200px' : '100%')};
  margin: 0 auto;

  & > :first-child {
    margin-bottom: 8px !important;
  }
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const ScrollableContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

export const ColumnsWrapper = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;
  align-items: flex-start;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
`;

export const LeftColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  max-width: 100%;

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
    align-items: center;

    & > * {
      width: 100%;
      max-width: 400px;
    }
  }
`;

export const RightColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: sticky;
  top: 16px;
  align-self: flex-start;
  height: fit-content;
  min-width: 0;
  max-width: 100%;

  @media (max-width: 768px) {
    position: static;
    max-height: none;
    overflow-y: visible;
    width: 100%;
    align-items: center;

    & > * {
      width: 100%;
      max-width: 400px; /* Limita el ancho máximo de los widgets en mobile */
    }
  }
`;

export const LoadingWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
